export function isEmail(str) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(str);
}

export function isCompletePhone(str) {
    
    return str.length == 14
}


export function isCompleteSSN(str) {
    
    return str.length == 11
}